module.exports = __webpack_public_path__ + "img/w1.1d1d93f7.svg";